import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function AskAiButtonUi({ onAskAi, uiType }) {
  const { t } = useTranslation();

  if (uiType === "assignedAssessmentPdfButton") {
    return (
      <Button
        onClick={onAskAi}
        className={"button secondary p-0 ms-2"}
        style={{ height: 35, minWidth: 35, borderRadius: "10px", borderColor: "#6366f1" }}
        title={t("askAi")}
      >
        <span style={{ fontSize: "14px" }}>AI</span>
      </Button>
    );
  } else {
    return (
      <Button
        className="_pdf-download-button ms-2"
        onClick={onAskAi}
        style={{ backgroundColor: "#6366f1", borderColor: "#6366f1" }}
      >
        {t("askAi")}
      </Button>
    );
  }
}
